import React, { useState } from "react";
import { PAGE_CONTENT_CLASS } from "../../../components/layout/PageContent";
import ContractMetrics from "../../../pages/contract-dashboard/components/ContractMetrics";
import ContractFilters from "../../../pages/contract-dashboard/components/ContractFilters";
import ContractTable from "../../../pages/contract-dashboard/components/ContractTable";
import ContractCardMobile from "../../../pages/contract-dashboard/components/ContractCardMobile";
import FakeAppChrome from "../FakeAppChrome";
import {
  TOUR_DASHBOARD_CONTRACTS,
  TOUR_DASHBOARD_USER,
} from "../tourData";

const noop = () => {};

const LIST_TABS = [
  { id: "todos", label: "Todos os Documentos" },
  { id: "modelos", label: "Modelos (Sistema)" },
  { id: "manuais", label: "Documentos Manuais" },
  { id: "templates", label: "Meus Modelos" },
  { id: "uploads", label: "Documentos Upload" },
];

/**
 * Frozen replica of /contract-dashboard using the same presentational pieces.
 */
const DashboardScene = () => {
  const [listTab, setListTab] = useState("todos");
  const [filters, setFilters] = useState({
    search: "",
    status: "all",
    type: "all",
  });
  const [sortKey, setSortKey] = useState("createdAt");
  const [sortDir, setSortDir] = useState("desc");

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSortColumn = (columnKey) => {
    if (sortKey === columnKey) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
      return;
    }
    setSortKey(columnKey);
    setSortDir("asc");
  };

  return (
    <FakeAppChrome activeNavId="home">
      <div className={`${PAGE_CONTENT_CLASS} !pt-6`}>
        <ContractMetrics user={TOUR_DASHBOARD_USER} showWhatsAppConnect={false} />

        <div data-tour="tour-documents-area">
          <ContractFilters
            filters={filters}
            onFilterChange={handleFilterChange}
            onClearFilters={() =>
              setFilters({ search: "", status: "all", type: "all" })
            }
            onRefresh={noop}
            onOpenAdvancedSearch={noop}
          />

          <div
            className="mb-6 -mx-4 flex gap-0 overflow-x-auto border-b border-border px-4 scrollbar-none md:mx-0 md:px-0"
            role="tablist"
            aria-label="Tipo de documento"
          >
            {LIST_TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={listTab === tab.id}
                onClick={() => setListTab(tab.id)}
                className={`-mb-px shrink-0 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
                  listTab === tab.id
                    ? "border-primary text-primary"
                    : "border-transparent text-muted-foreground hover:text-foreground"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <p className="mb-4 text-xs text-muted-foreground">
            Clique duas vezes para editar os documentos
          </p>

          <div className="hidden md:block">
            <ContractTable
              contracts={TOUR_DASHBOARD_CONTRACTS}
              mixed={listTab === "todos"}
              sortKey={sortKey}
              sortDir={sortDir}
              onSortColumn={handleSortColumn}
              onDownload={noop}
              onEdit={noop}
              onDelete={noop}
              onSendToSignature={noop}
              onDuplicateContract={noop}
              onCancelSignature={noop}
              onViewSignatureStatus={noop}
              onGeneratePdf={noop}
              onViewPdf={noop}
            />
          </div>

          <div className="space-y-4 md:hidden">
            {TOUR_DASHBOARD_CONTRACTS.map((contract) => (
              <ContractCardMobile
                key={contract.id}
                contract={contract}
                onDownload={noop}
                onEdit={noop}
                onDelete={noop}
                onSendToSignature={noop}
                onDuplicateContract={noop}
                onCancelSignature={noop}
                onViewSignatureStatus={noop}
                onGeneratePdf={noop}
                onViewPdf={noop}
              />
            ))}
          </div>
        </div>
      </div>
    </FakeAppChrome>
  );
};

export default DashboardScene;
